import { useQuery } from "@tanstack/react-query";

import { useEmployeeApi } from "~/lib/api/common";

export function useEmployeesStatus() {
  const api = useEmployeeApi();
  return useQuery({
    queryKey: ["employeesStatus"],
    queryFn: () => api.getEmployeeStatuses(),
    refetchInterval: 1000 * 5,
  });
}
